import CRMTripManagement from "../Trips";

export default function CRMDisneyWorld() {
  return <CRMTripManagement destination="disney_world" />;
}
